/**
 * FMF Hero Event Timer Component
 *
 * COUNTDOWN CONFIGURATION:
 * 1. Single Source of Truth: Set `data-event-date="YYYY-MM-DDTHH:mm:ss"` on the `.fmf-hero-event-timer` HTML element
 *    or pass `{{> hero-event-timer eventDate="YYYY-MM-DDTHH:mm:ss"}}` in Handlebars templates.
 * 2. Global Fallback: `DEFAULT_EVENT_DATE` below sets the default target date site-wide if no attribute is provided.
 */
export const DEFAULT_EVENT_DATE = '2027-01-12T00:00:00';

export function initHeroEventTimer() {
  const timerElements = document.querySelectorAll('.fmf-hero-event-timer');
  if (!timerElements.length) return;

  timerElements.forEach((timerEl) => {
    const rawDate = timerEl.getAttribute('data-event-date') || DEFAULT_EVENT_DATE;
    const targetDate = new Date(rawDate).getTime();

    const daysEl = timerEl.querySelector('[data-timer-days]');
    const hoursEl = timerEl.querySelector('[data-timer-hours]');
    const minutesEl = timerEl.querySelector('[data-timer-minutes]');
    const secondsEl = timerEl.querySelector('[data-timer-seconds]');

    function updateTimer() {
      const now = Date.now();
      const diff = targetDate - now;

      if (isNaN(targetDate) || diff <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minutesEl) minutesEl.textContent = '00';
        if (secondsEl) secondsEl.textContent = '00';
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      if (daysEl) {
        daysEl.textContent = days >= 100 ? String(days) : String(days).padStart(2, '0');
      }
      if (hoursEl) {
        hoursEl.textContent = String(hours).padStart(2, '0');
      }
      if (minutesEl) {
        minutesEl.textContent = String(minutes).padStart(2, '0');
      }
      if (secondsEl) {
        secondsEl.textContent = String(seconds).padStart(2, '0');
      }
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroEventTimer);
} else {
  initHeroEventTimer();
}
